import { createSlice } from "@reduxjs/toolkit";

// Chat no implementado en FastAPI todavía — stub que mantiene el shape del estado
// sin lanzar errores. Los componentes de chat mostrarán vacío.

export const chatReducer = createSlice({
    name: 'chat',
    initialState: {
        my_friends: [],
        fb_messages: [],
        currentFd: '',
        errorMessage: '',
        successMessage: '',
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = ''
            state.successMessage = ''
        },
        updateMessage: (state, { payload }) => {
            state.fb_messages = [...state.fb_messages, payload]
        }
    },
    extraReducers: () => {}
})

export const { messageClear, updateMessage } = chatReducer.actions
export default chatReducer.reducer

// Stubs exportados para que los componentes no necesiten cambios de importación
export const add_friend = () => async () => {}
export const send_message = () => async () => {}
